
//import "react-responsive-carousel/lib/styles/carousel.min.css";
//import { Carousel } from 'react-responsive-carousel';
import React, { useEffect, useState, useMemo } from 'react';
import '../../src/Styles.css';
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import HomeDrawer from '../Components/HomeDrawer';


const AboutUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const [themeTextColor, setTheme] = useState(null);

    const isDark = undefined;
    // Detecting the default theme
    const systemPrefersDark = useMediaQuery(
        {
            query: "(prefers-color-scheme: dark)",
        },
        undefined
    );


    const value = useMemo(
        () => (isDark === undefined ? !!systemPrefersDark : isDark),
        [isDark, systemPrefersDark]
    );

    useEffect(() => {
        if (value) {
            setTheme('#fff')
        } else {
            setTheme('#111')
        }
    }, [value]);
    return (

        <div className='blog-div-container'>
            <div>
                <HomeDrawer />
            </div>

            <div className='blog-content'>

                <Link style={{ textDecoration: 'none' }} className="App-link" to="/">
                    <div className="logo" ><h1 style={{ color: themeTextColor, }}>Africa Match</h1></div>
                </Link>

                <h2 className='blog-pargraph-title' style={{ color: themeTextColor }}>Acerca de</h2>

                <div >

                    <div >
                        <p className='blog-pargraph' style={{ color: themeTextColor }} >
                        ¡Bienvenido a Raguay, la comunidad donde los paraguayos solteros se conectan! Ya sea que estés en Asunción,
Ciudad del Este, Encarnación o en cualquier lugar de nuestra hermosa nación, Raguay reúne a los lugareños
para establecer conexiones significativas.</p>
                    </div>

                    <div className='about-pargraph1'>
                        <p className='blog-pargraph' style={{ color: themeTextColor }}>
                        Raguay es una aplicación de citas diseñada para solteros en Paraguay y es propiedad de Yana Plus LLC y está operada por ella. Con Raguay, puedes encontrar relaciones serias, conocer nuevos amigos, salir con alguien
y hacer conexiones significativas. Hemos creado un entorno de citas en línea emocionante para aquellos
que estén listos para abrazar el mundo de las citas. Nuestras funciones están diseñadas para ayudarte a construir relaciones que vayan más allá de ser solo amigos.
                        </p>
                    </div>

                    <h2 className='blog-pargraph-sub-title' style={{ color: themeTextColor }}>Nuestra misión</h2>

                    <div >
                        <p className='blog-pargraph' style={{ color: themeTextColor }}>
                        Nuestra misión es simple: ayudar a los solteros en Paraguay a encontrar el amor con conexiones significativas a través de las citas en línea.
                        </p>
                    </div>


                    <div className='about-pargraph1'>
                        <p className='blog-pargraph' style={{ color: themeTextColor }}>
                        Únase a los miles de solteros antillanos que buscan a su pareja de una manera divertida y sencilla: ¡descargue Raguay y disfrute hoy mismo de la mejor aplicación de citas en línea!
                        </p>
                    </div>

                    <div className='footer' style={{ marginTop: '3%' }}>


                       <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/about-us">Acerca de</Link>
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/about-us"> | </Link>
                       
                       
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/dating-tips">Consejos para citas</Link>
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/dating-tips"> | </Link>
                       
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/safety-tips">Consejos de seguridad para las citas</Link>
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/safety-tips"> | </Link>
                       
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/privacy-policy">Política de privacidad</Link>
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/privacy-policy"> | </Link>
                       
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/terms-conditions">Términos y condiciones</Link>
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/terms-conditions"> | </Link>
                       
                                 <Link className='pargrah-font' style={{ textDecoration: 'none', margin: '1%', color: themeTextColor, }} to="/contact-us">Apoyo</Link>

                    </div>

                    <div className='copy-right'>
                        <p className='pargrah-font' style={{ color: themeTextColor }}>@2025 Yana Plus LLC.</p>
                    </div>

                </div>
            </div>
        </div>

    );
}

export default AboutUs;
